    import {ApiService} from "./api-service";

    export async function loginUser(username: string, password: string) {
        try {
            const response = await ApiService.getInstance().post("/login", {
                username: username,
                password: password
            });
            return response.data;
        } catch (error) {
            return error as Error;
        }
    }

    export async function fetchMyProfile() {
        try {
          const token = localStorage.getItem("token");
      
          if (!token) {
            throw new Error("Token is missing");
          }
      
          const response = await ApiService.getInstance().get("/users/me", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
      
          return response.data; // You can process this further depending on your frontend logic
        } catch (error) {
          console.error("Error fetching profile:", error);
          return error as Error;
        }
      }
      
